import React, { Component } from "react";

import RaterRow from "./RaterRow";
import RaterSelector from "./RaterSelector";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles, withStyles } from '@material-ui/core/styles';

class RaterList extends Component {
	

	constructor(props) {
        super(props);
		this.state= {
			loading: false,
			dialogOpen: false,
			currentLang: 0
		}
		this.addUser=this.addUser.bind(this);
		this.orderLangPairs=this.orderLangPairs.bind(this);
		this.handleSelectorClose=this.handleSelectorClose.bind(this);
		this.filterLangPairs=this.filterLangPairs.bind(this);
		this.updateRaters=this.updateRaters.bind(this);
    }
	
	addUser(langPairId){
		this.setState({dialogOpen: true, currentLang: langPairId});
	}
	
	orderLangPairs(a, b){
		let trgA = a.code.split("-").at(1);
		let trgB = b.code.split("-").at(1);

		return trgA.localeCompare(trgB);
	}
	
	filterLangPairs(element){
		return element.code.includes("-");
	}
	
	handleSelectorClose(){
		this.setState({dialogOpen: false});
	}
	
	handleSelectorOpen(){
		this.setState({dialogOpen: true});
	}
	
	updateRaters(pairId, canvis){
		this.props.updateRaters(pairId, canvis);
		this.handleSelectorClose();
	}
	
	render() {
		const rows = [];
			let users = [];
			Object.values(this.props.langPairs).filter(this.filterLangPairs).sort(this.orderLangPairs).forEach(element => rows.push(
				<RaterRow
					key={element.id}
					id={element.id}
					langPair={element}
					users={this.props.raters[element.id]}
					addUser={this.addUser}
					handleMorePriority={this.props.handleMorePriority}/>
			));

		return (
			<div className="content">
			<table className="table table-striped table-hover lst">
				<thead>
				<tr>
					<th>Id</th>
					<th>LanguagePair</th>
					<th>Raters</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>{rows}</tbody>
			</table>
			<RaterSelector
				users		= {this.props.users}
				raters		= {typeof this.props.raters[this.state.currentLang] != 'undefined' ? this.props.raters[this.state.currentLang] : []}
				currentLang	= {this.state.currentLang}
				dialogOpen	= {this.state.dialogOpen}
				dialogClose	= {this.handleSelectorClose}
				updateRaters= {this.updateRaters}
			/>
			</div>
		);
  }
};

export default RaterList;